export const PAGE_STATE_PARAMS = ['search', 'orderBy']

export function getPaginatedPath(basePath, page) {
  const pathWithoutPage = basePath.replace(/\/page\/\d+\/?$/, '').replace(/\/$/, '')

  return page === 1 ? pathWithoutPage : `${pathWithoutPage}/page/${page}`
}

export function getPaginatedHrefClean(basePath, page, query) {
  const path = getPaginatedPath(basePath, page)
  if (page === 1) return path

  const url = new URLSearchParams()
  for (const key of PAGE_STATE_PARAMS) {
    const value = query?.[key]
    if (value != null && value !== '') {
      url.set(key, Array.isArray(value) ? value[0] : value)
    }
  }
  const qs = url.toString()
  return qs ? `${path}?${qs}` : path
}

export function getPaginatedCategoryHref(basePath, page, query) {
  const path = getPaginatedPath(basePath, page)
  if (page === 1) return path

  const url = new URLSearchParams(query)
  url.delete('page')
  const qs = url.toString()
  return qs ? `${path}?${qs}` : path
}
